exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.date-picker .el-range-input {\r\n  width: 36%;\n}\n.date-picker .el-range-separator {\r\n  width: 8%;\n}\n.el-input .el-input-group__prepend {\r\n  background: #FFFFFF;\n}\n.el-notification .el-notification__content {\r\n  margin: 3px 0 0;\n}\nbutton, input, optgroup, select, textarea {\r\n  font-family: PingFangSC Regular;\r\n  font-size: 0.8rem;\n}\n.el-tabs .el-tabs__content {\r\n  padding: 20px 0;\n}\r\n", ""]);

// exports
